import DOMPurify from 'dompurify';
import axios from 'axios';
import _ from 'lodash';

let activeModal = false;
const INTERVAL_CHECKER = 60000;
const throttledUpdateUserActivity = _.throttle(
  updateServerSession,
  INTERVAL_CHECKER,
  { leading: true, trailing: false }
);

async function startSessionTracking() {
  const events = [
    'mousedown',
    'mouseup',
    'mousemove',
    'keydown',
    'keypress',
    'scroll',
    'touchstart',
    'click',
    'submit',
    'change',
    'mouseenter',
    'resize',
    'focus',
    'blur',
    'touchmove',
    'touchend',
    'touchcancel',
    'touchleave',
    'touchenter',
  ];

  events.forEach((event) => {
    document.addEventListener(event, throttledUpdateUserActivity);
  });

  await updateServerSession();
  setInterval(checkSessionExpirationOnServer, INTERVAL_CHECKER); // CHECK EVERY MINUTE
}

async function checkSessionExpirationOnServer() {
  try {
    const { data } = await axios.get('/check-session-expiration');
    const sessionTimeRemaining = data.timeRemaining;
    if (data.showModal && !activeModal) {
      if (document.getElementById('idleTimerModal')) {
        // Exit fullscreen mode
        if (document.fullscreenElement) {
          document.exitFullscreen();
        } else if (document.mozFullScreenElement) {
          // Firefox
          document.mozCancelFullScreen();
        } else if (document.webkitFullscreenElement) {
          // Chrome, Safari and Opera
          document.webkitExitFullscreen();
        } else if (document.msFullscreenElement) {
          // IE/Edge
          document.msExitFullscreen();
        }
        $('#idleTimerModal').modal('show');
        activeModal = true;
      }
    }
    if (sessionTimeRemaining <= 0) {
      autoLogout();
    }
  } catch (err) {
    let body = {
      message: err.message,
      status: err.response ? err.response.status : 'unknown',
    };
    await axios.post('/log-error', body);
  }
}

async function updateServerSession() {
  try {
    await axios.post('/update-user-activity');
  } catch (err) {
    let body = {
      message: err.message,
      status: err.response ? err.response.status : 'unknown',
    };
    await axios.post('/log-error', body);
  }
}

function autoLogout() {
  const newLocation = `${window.location.origin}/auto-logout?redirect=${window.location.pathname}`;
  window.location.href = DOMPurify.sanitize(newLocation);
}

async function checkUserLoggedIn() {
  if (!document.getElementById('idleTimerModal') || window.isAuthenticated) {
    await startSessionTracking();
  }
}

window.addEventListener('load', checkUserLoggedIn);

document.addEventListener('DOMContentLoaded', function () {
  const stayLoggedInButton = document.getElementById('stayLoggedInButton');
  if (stayLoggedInButton) {
    stayLoggedInButton.addEventListener('click', async function () {
      activeModal = false;
      await updateServerSession();
    });
  }
});
